module.exports = __webpack_public_path__ + "static/media/gryllotalpa_gryllotalpa_003_APA.3307e7ec.png";